import React from 'react';
import IafsTable from './IafsTable';

function InsuranceIafsTable({ iafs }) {
  return <IafsTable title="Compensi da assicurazioni" iafs={iafs} />;
}

export default InsuranceIafsTable;
